import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import Spinner from '../../../../components/Spinner'
import styled from 'styled-components';
import { SelectWrapper, InnerBox } from '../../Admin/DashBoard/dashBoardStyled'
import Button from 'web/components/Button';

import { Heading, TableWrapper } from 'web/pages/private/Admin/adminStyled'
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';
import { getReferralCodeDetailsApi, updateReferralCodeDetailsApi, updateReferralCodeStatusApi } from '../../../../../redux/actions/admin';
import AlertModal from 'web/components/AlertModal';

function ReferralCode() {
    let dispatch = useDispatch()
    let history = useHistory()
    const loaderVisible = useSelector(state => state.appReducer.loaderVisible);
    const adminRoles = useSelector(state => state.admin.adminRoles)
    const [modal, setModal] = useState(false);
    const [modalContent, setModalContent] = useState('');
    const toggleModal = () => setModal(!modal);
    const [pageData, setPageData] = useState({})
    const timeSpanSelect = [{ label: 'Days', value: 'DAY' }, { label: 'Months', value: 'MONTH' }, { label: 'Years', value: 'YEAR' }]
    const [pageValueUpdates, setPageValueUpdates] = useState({
        ownerBenefit: 'freeSubscription',
        ownerBenefitDuration: 0,
        ownerBenefitType: 'DAY',
        inviteeBenefit: 'freeSubscription',
        inviteeBenefitDuration: 0,
        inviteeBenefitType: 'DAY',
        minReqReferrals: 0
    })

    useEffect(() => {
        let userRole = localStorage.getItem('accountType')
        let appUserRolesList = ['Both', 'Buyer', 'Seller']
        if (userRole !== 'Admin') {
            if (appUserRolesList.includes(userRole)) history.push('/dashboard')
            else history.push('/sign-in')
            window.location.reload();
        }
        fetchPageData()
    }, [])

    const fetchPageData = async () => {
        let response = await dispatch(getReferralCodeDetailsApi());
        if (response.data && response.data.status === 'SUCCESS') {
            let apiResponseData = response.data.payload
            setPageData(apiResponseData)
            setPageValueUpdates({
                ownerBenefit: 'freeSubscription',
                ownerBenefitDuration: apiResponseData.ownerBenefitDuration,
                ownerBenefitType: apiResponseData.ownerBenefitType,
                inviteeBenefit: 'freeSubscription',
                inviteeBenefitDuration: apiResponseData.invitedBenefitDuration,
                inviteeBenefitType: apiResponseData.invitedBenefitType,
                minReqReferrals: apiResponseData.minimumReferralRequired
            })
        } else {
            if (response.statusCode === 401) {
                history.push('/sign-in')
                window.location.reload(false);
            } else {
                setModalContent(response.data.message)
                setModal(!modal)
            }
        }
    }

    const handleChange = (e) => {
        const numberRegex = /^[0-9\b]+$/;
        if (e.target.id === "minReqReferrals") {
            if (e.target.value === '' || (numberRegex.test(e.target.value) && parseInt(e.target.value) < 5001)) {
                setPageValueUpdates({
                    ...pageValueUpdates,
                    [e.target.id]: e.target.value
                })
            }
        } else if (e.target.id === "ownerBenefitDuration" || e.target.id === "inviteeBenefitDuration") {
            if (e.target.value === '' || (numberRegex.test(e.target.value) && parseInt(e.target.value) < 32)) {
                setPageValueUpdates({
                    ...pageValueUpdates,
                    [e.target.id]: e.target.value
                })
            }
        } else {
            setPageValueUpdates({
                ...pageValueUpdates,
                [e.target.id]: e.target.value
            })
        }
    }

    const handleStatusChange = async (e) => {
        e.preventDefault()
        let response = await dispatch(updateReferralCodeStatusApi(!pageData.referralCodesActive))
        if (response.status === 'SUCCESS') {
            fetchPageData()
            setModalContent('Status Updated.');
            toggleModal();
        } else {
            if (response.statusCode === 401) {
                history.push('./sign-in')
                window.location.reload(false);
            } else {
                setModalContent(response.message);
                toggleModal();
            }
        }
    }

    const updateReferralDetails = async () => {
        let data = {
            "ownerBenefitType": pageValueUpdates.ownerBenefitType,
            "ownerBenefitDuration": pageValueUpdates.ownerBenefitDuration === '' ? 0 : pageValueUpdates.ownerBenefitDuration,
            "invitedBenefitDuration": pageValueUpdates.inviteeBenefitDuration === '' ? 0 : pageValueUpdates.inviteeBenefitDuration,
            "invitedBenefitType": pageValueUpdates.inviteeBenefitType,
            "minimumReferralRequired": pageValueUpdates.minReqReferrals === '' ? 0 : pageValueUpdates.minReqReferrals
        }
        if (parseInt(pageValueUpdates.ownerBenefitDuration) === 0 || parseInt(pageValueUpdates.inviteeBenefitDuration) === 0 || parseInt(pageValueUpdates.minReqReferrals) === 0) {
            setModalContent("Value should be greater than 0.");
            toggleModal();
        } else {
            let response = await dispatch(updateReferralCodeDetailsApi(data))
            if (response.status === 'SUCCESS') {
                fetchPageData()
                setModalContent(response.message);
                toggleModal();
            } else {
                if (response.statusCode === 401) {
                    history.push('./sign-in')
                    window.location.reload(false);
                } else {
                    setModalContent(response.message);
                    toggleModal();
                }
            }
        }
    }


    return (
        <>
            {(adminRoles && (adminRoles.includes('SUPER_ADMIN') || adminRoles.includes('REFERRAL_CODE'))) ?
                <>
                    <TableWrapper>
                        {loaderVisible && <Spinner />}
                        <Heading>
                            <h3>Referral Code Settings</h3>
                        </Heading>
                        <CodeId>
                            <div style={{ display: 'flex', justifyContent: 'space-between', flexWrap: 'wrap', alignItems: 'center' }}>
                                <h4>{pageData && pageData.referralCodesActive ? 'Deactivate Referral Code' : 'Activate Referral Code'} </h4>
                                <FormControlLabel
                                    style={{ margin: 0 }}
                                    labelPlacement="start"
                                    label={pageData && pageData.referralCodesActive ? 'Active' : 'Inactive'}
                                    control={
                                        <Switch
                                            checked={pageData.referralCodesActive ? true : false}
                                            onClick={e => handleStatusChange(e)}
                                            name="checkedB"
                                            color="primary"
                                        />
                                    }
                                />
                            </div>
                        </CodeId>
                    </TableWrapper>
                    <TableWrapper>
                        {loaderVisible && <Spinner />}
                        <Heading>
                            <h3>Discount Type</h3>
                        </Heading>
                        <div className='col-sm-12'>
                            <InnerBox className='row'>
                                <div className='col-md-12 flex-wrapper'>
                                    <div>
                                        <SelectWrapper>
                                            <label>For code owner</label>

                                            <select id='ownerBenefit' value={pageValueUpdates.ownerBenefit}
                                                onChange={handleChange}>
                                                <option value='freeSubscription'>Free Subscription</option>
                                                {/* <option value='discountPercentage'>Percentage discount in subscription fee</option> */}
                                            </select>
                                        </SelectWrapper>

                                    </div>
                                    <div>
                                        <div className='flex-wrapper'>
                                            <SelectWrapper>
                                                <label>Time Span for benefits</label>

                                                <input id='ownerBenefitDuration' value={pageValueUpdates.ownerBenefitDuration}
                                                    placeholder='No. of' onChange={handleChange} />
                                            </SelectWrapper>

                                            <SelectWrapper>
                                                <label className='web-view'>&nbsp;</label>

                                                <select id='ownerBenefitType' value={pageValueUpdates.ownerBenefitType}
                                                    onChange={handleChange}
                                                >
                                                    {timeSpanSelect.map(val => (
                                                        <option value={val.value}>{val.label}</option>
                                                    ))}
                                                </select>
                                            </SelectWrapper>

                                        </div>
                                    </div>
                                </div>
                            </InnerBox>
                            <InnerBox className='row'>
                                <div className='col-md-12 flex-wrapper'>
                                    <div>
                                        <SelectWrapper>
                                            <label>For Invited Member</label>

                                            <select id='inviteeBenefit' value={pageValueUpdates.inviteeBenefit}
                                                onChange={handleChange}
                                            >
                                                <option value='freeSubscription'>Free Subscription</option>
                                                {/* <option value='discountPercentage'>Percentage discount in subscription fee</option> */}
                                            </select>
                                        </SelectWrapper>

                                    </div>
                                    <div>
                                        <div className='flex-wrapper'>
                                            <SelectWrapper>
                                                <label>Time Span for benefits</label>

                                                <input id='inviteeBenefitDuration' value={pageValueUpdates.inviteeBenefitDuration} placeholder='No. of'
                                                    onChange={handleChange}
                                                />
                                            </SelectWrapper>

                                            <SelectWrapper>
                                                <label className='web-view'>&nbsp;</label>

                                                <select id='inviteeBenefitType' value={pageValueUpdates.inviteeBenefitType}
                                                    onChange={handleChange}
                                                >
                                                    {timeSpanSelect.map(val => (
                                                        <option value={val.value}>{val.label}</option>
                                                    ))}
                                                </select>
                                            </SelectWrapper>

                                        </div>
                                    </div>
                                </div>
                            </InnerBox>
                        </div>
                        <div className='col-sm-12'>
                            <InnerBox className='row'>
                                <div className='col-md-12 flex-wrapper'>
                                    <div>
                                        <SelectWrapper>
                                            <label>Minimum No. Of People To Refer</label>

                                            <input id='minReqReferrals' value={pageValueUpdates.minReqReferrals} placeholder='No. of People'
                                                onChange={handleChange}
                                            />
                                        </SelectWrapper>

                                    </div>
                                </div>

                            </InnerBox>
                        </div>
                        <div className='col-sm-12' style={{ marginBottom: '10px' }}>
                            <Button
                                type='app-green-button submitBtn'
                                handleClick={() => updateReferralDetails()}
                            >
                                Apply Changes
                            </Button>
                        </div>
                    </TableWrapper>

                    <AlertModal
                        isOpen={modal}
                        toggle={toggleModal}
                        title=''
                        content={modalContent}
                    />
                </>

                :

                <p>You are not authorized to view this page.</p>
            }
        </>

    )
};

export default ReferralCode;


const CodeId = styled.div`
    padding: 34px 15px;
        h4 {
            font-size: 18px;
            flex-flow: 1;
            font-family: 'latosemibold';

        }
    `